import api from "./Api";

class IntegracaoService {
    async integrar(integracaoId: number, dataInicial: string, dataFinal: string): Promise<void> {
        await api.post(`Integracao/${integracaoId}/importar`, {
            empresaId: 0,
            dataInicio: dataInicial,
            dataFim: dataFinal,
        });
    }

    async integrarAtlantica(integracaoId: number, empresaId: number, dataInicio: string, dataFim: string, manterDados = false): Promise<void> {
        await api.post(`Integracao/${integracaoId}/importar`, { empresaId, dataInicio, dataFim, manterDados });
    }

    // Diz se já existe importação com o mesmo período inicial (e final igual ou menor) cujos dados podem ser mantidos.
    async verificarReaproveitamento(integracaoId: number, empresaId: number, dataInicio: string, dataFim: string):
        Promise<{ podeManter: boolean; esteiraId?: number | null; periodoInicio?: string | null; periodoFim?: string | null }> {
        const response = await api.get(`Integracao/${integracaoId}/verificar-reaproveitamento`, { params: { empresaId, dataInicio, dataFim } });
        return response.data;
    }

    // Integração ativa do cliente logado; semEcd = importa da própria origem, sem ECD nem esteira anterior.
    async minha(): Promise<{ id: number; nomeSistema: string | null; semEcd: boolean } | null> {
        const response = await api.get(`Integracao/minha`);
        return response.data ?? null;
    }

    async cadastrarEmpresas(integracaoId: number): Promise<void> {
        await api.post(`Integracao/${integracaoId}/sincronizar-empresas`);
    }

    async statusAtlantica(): Promise<any> {
        const response = await api.get(`Esteira/status-integracao`);
        return response.data;
    }

    async steps(esteiraId: number): Promise<any[]> {
        const response = await api.get(`Integracao/${esteiraId}/steps`);
        return response.data;
    }
}


export default new IntegracaoService();
